import {
  useShadowRootElements,
  useTechDocsReaderPage,
} from '@backstage/plugin-techdocs-react';
import { Box, Button } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';

export type EditWikiProps = {};

export const EditWikiAddon = ({}: EditWikiProps) => {
  const {
    entityMetadata: { value: entityMetadata, loading: entityMetadataLoading },
  } = useTechDocsReaderPage();

  const [pagePathElement] = useShadowRootElements<HTMLElement>([
    '[data-page-path]',
  ]);

  if (entityMetadata === undefined && !entityMetadataLoading) return null;

  const { locationMetadata } = entityMetadata || {};

  if (
    !locationMetadata ||
    locationMetadata.type === 'dir' ||
    locationMetadata.type === 'file'
  )
    return null;

  const targetUrl = new URL(locationMetadata.target);

  if (
    !targetUrl.pathname.includes('/_git/') ||
    targetUrl.searchParams.get('version') !== 'GBwikiMaster'
  )
    return null;

  targetUrl.pathname = targetUrl.pathname.replace('/_git/', '/_wiki/wikis/');

  const dataPagePath = pagePathElement?.dataset.pagePath;

  if (!dataPagePath) return null;

  const pagePath = dataPagePath
    .split('/')
    .map(s => encodeURIComponent(s).replace(/-/g, '%2D'))
    .join('/');

  const editUrl = `${targetUrl.origin}${targetUrl.pathname}?wikiVersion=GBwikiMaster&_a=edit&pagePath=${pagePath}`;

  return (
    <Box sx={{ py: 2 }}>
      <Button
        color="primary"
        startIcon={<EditIcon />}
        href={editUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        Edit Wiki
      </Button>
    </Box>
  );
};
